import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import cdfinance_logo from "../../images/cd-finance-logo.png"
import no_poverty from "../../images/no-poverty.png"
import decent_work from "../../images/decent-work.png"
import reduced_inequalities from "../../images/reduced-inequalities.png"

const CdFinanceMapDetail = () => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid item lg={3} xl={2}>
          <Image
            src={cdfinance_logo}
            width="865px"
            height="306px"
            isResponsive
            disableLoader
            alt="CD finance"
            style={{ backgroundSize: "cover", backgroundPosition: "center" }}
          />
          {/* <StaticImage
            src="../../images/cd-finance-logo.png"
            alt="CD finance"
            layout="fullWidth"
          /> */}
        </Grid>
      </Grid>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid item lg={3} xl={2} container spacing={2}>
          <Grid item xs={6}>
            <Image
              src={no_poverty}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="no poverty"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/no-poverty.png"
              alt="no poverty"
              layout="fullWidth"
            /> */}
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <Image
              src={decent_work}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="decent work and economic growth"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/decent-work.png"
              alt="decent work and economic growth"
              layout="fullWidth"
            /> */}
          </Grid>
          <Grid item xs={6}>
            <Image
              src={reduced_inequalities}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="reduced inequalities"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/reduced-inequalities.png"
              alt="reduced inequalities"
              layout="fullWidth"
            /> */}
          </Grid>
        </Grid>
        <Grid item lg={9} xl={10} container>
          <Grid item xs={12}>
            <StyledDetailHeader>Microfinance</StyledDetailHeader>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailLocation>Based in China</StyledDetailLocation>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              borderBottom: "3px solid #0F6494",
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            container
            alignItems="center"
          >
            <Grid item xs={6}>
              <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
            </Grid>
            <Grid item xs={6}>
              <StyledDetailSubheaderContent>
                Financial & Digital Inclusion
              </StyledDetailSubheaderContent>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              About the Company
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Microfinance institution providing financial services to rural
              populations in China.
            </StyledDetailSubheaderContent>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              Impact Thesis
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Providing access to safe and affordable financial solutions to
              boost economic growth in rural China while reducing poverty and
              inequalities.
            </StyledDetailSubheaderContent>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default CdFinanceMapDetail
